// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Evml0","right":"Footer_right__FVAqw","buttons":"Footer_buttons__AKIs8"};